import { Navigate } from 'react-router';

import { ANY_SPORT_SCORES_TOP_PLAYERS_EVENTTYPE_FIXTURE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { useLastVisitedEventType } from '#src/hooks/useLastVisitedEventType.ts';

export const PlayPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { lastVisitedEventType } = useLastVisitedEventType();

  return (
    <Navigate
      to={generateSportContextPath(
        ANY_SPORT_SCORES_TOP_PLAYERS_EVENTTYPE_FIXTURE,
        {
          params: {
            eventType: lastVisitedEventType,
            fixture: 'ongoing',
          },
        }
      )}
      replace
    />
  );
};

export default PlayPage;
